var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51.35 182.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3b792;}.cls-2{fill:#1299a1;}.cls-3{fill:#232323;}.cls-4{fill:#004568;}.cls-5{fill:#0d5278;}.cls-6{fill:#12adb2;}.cls-7{fill:#7a6048;}.cls-8{fill:none;stroke:#1299a1;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Male_05a",
    "data-name": "Staff_Male_05a",
    viewBox: "0 0 51.35 182.59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.3,83.07l-2.23-2L45,76.22,42.32,61S41.7,43.4,40.65,37.84s-1.94-8.51-7.52-7.94c-4.9.51-3.5,6.06-3.15,11.29s3.69,17.69,4.36,20.1c.81,3,2.24,9.08,3.65,14.63.23,1.44,2.56,5.93,3.16,9.15a21.18,21.18,0,0,0,2.3,6.26C44,92.7,47,96.19,49.7,94.51c.84-.52-2-7.68-2-7.68s2.41,3.34,3.41,3.13C52.31,89.71,48.3,83.07,48.3,83.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.71,48a66.33,66.33,0,0,1,11.87-2.66,74.94,74.94,0,0,0-.78-8c-1-5.55-3.35-9.67-8.93-9.09-4.9.5-3.5,6.06-3.15,11.28C29.84,41.31,30.23,44.51,30.71,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.48,156.46c0,2.35-.7,5.39,0,6.23s5.78,1.35,8.23,2.86,1.75,3,6.47,3.54c5.78.67,8.76-1.69,4-4.55-5-3-6.3-3.7-9.45-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.78,80.49c.35,8.25-1.92,35.88-2.27,45.65s-.7,25.77-.35,29.47-11,6.07-11.38.51.7-22.74.52-32.51-2.45-41.1-2.45-41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.69,166c.18,4.55-1.92,9.43-.17,12.8s5.77,4,8.4,3.71,3-4,2.1-6.91-2.45-7.07-3-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.27,82.79c-.88,10.61-1.19,39.46-2.45,47.84-1.58,10.44-1.75,29.81-1.4,34.19s11.9,6.07,11.72.84,1.23-21.39,2.28-31.49S28,103.34,29.75,95.76c1.29-5.61.52-14,.52-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.28,27C33.61,24.62,38,31.75,38.91,37s1.22,40.42,1.4,44-10,3.87-14.36,4.21-15,2.86-15.57-2.7S7.57,49.1,7.57,42.7,8.1,30.07,22.28,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.8,24.85c-2.62.33-6.65,2.52-7.52,4.21S24.2,40.34,24.2,40.34l4.91-6.56,5.07,4C33.83,34.11,31,26.2,27.53,25.18S22.8,24.85,22.8,24.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.58,93.62c-.8-1.5-4.84-4.07-4.84-4.07L12.22,84.3c-1.28-3.37-2.77-13.43-3.47-17.53a68.48,68.48,0,0,1,4.61-15.83c3.68-8.76,1.06-15.41-2.8-15.66-5.08-.34-6.91,5.33-8.48,10.21S-.27,66.24.08,69.27s2.45,9.52,6,17.54c0,0,2,3.94,3.05,5.87s.77,6.1,2,8.08,5.27,6.15,8.42,5.23c2.13-.61-1.79-4.66-2.19-5.67a9.42,9.42,0,0,1,.05-3.53s3.49,4.51,4.64,3.82S20.38,95.12,19.58,93.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.38,26.87l1.4-4.55c-3.33-6.06-3.33-10.11-2.45-13.81S20.53.59,27,1.27s8.64,3.61,9.16,7.31,2.05,15.76,0,17.62-5.95,2-5.95,2l-1.05,5.56a18,18,0,0,1-7-2.53A19.19,19.19,0,0,1,17.38,26.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.78,22.32c-2.37-1.68-4.38-5.3-4.55-10.44S17.37-.16,25.69,0,37,4.79,37.66,8.58s-8.15,5-12.76.1a36.13,36.13,0,0,1-1.13,4.88s-1.34-2.48-3.07-.92c-1.31,1.18-1.49,5.81,1.4,6C21.67,20.22,18.78,22.32,18.78,22.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.06,54.19c.52-1.84,1-3.75,1.57-5.65,2.51-9.16-.94-15.42-4.8-15.17-5.08.32-7.36,5.89-8.28,10.94C1.26,45.84.8,48.61.3,51.79A98.89,98.89,0,0,1,13.06,54.19Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 29.11,
    y1: 33.78,
    x2: 31.34,
    y2: 53.14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation_-_Handlinger",
    "data-name": "Vask & Sterilisation - Handlinger"
  }, /*#__PURE__*/React.createElement("use", {
    width: 51.35,
    height: 182.59,
    xlinkHref: "#Staff_Male_05a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff1B);
export default __webpack_public_path__ + "static/media/staff-1-b.aa73dfda42e6e5f27fa761a232141186.svg";
export { ForwardRef as ReactComponent };